import React from 'react';

import { css } from '@emotion/react';
import { CssVars, NeutralColorToken, Type, mediaQueryForExperimentalLayoutSizeMDOrSmaller } from '@robinhood/design';
import { CARD_APP_STORE_URL, CARD_PLAY_STORE_URL } from '@x1/ui-web/constants/Links';
import { detectPlatform } from '@x1/ui-web/lib/detectPlatform';

import Button from 'src/components/creditApplication/Button';
import { CREDIT_APPLICATION_PAGE_MAX_WIDTH } from 'src/components/creditApplication/constants/dimensions';
import { IMAGES } from 'src/constants/assets';

const DownloadAppPageMobile = () => {
  const downloadLink = React.useMemo(() => {
    const platform = detectPlatform();
    return platform === 'iOS' ? CARD_APP_STORE_URL : CARD_PLAY_STORE_URL;
  }, []);

  return (
    <div css={root}>
      <div css={imageContainer}>
        <img src={IMAGES.downloadAppSplash} alt='Banking App Logo' css={image} />
      </div>
      <div css={page}>
        <div css={contentContainer}>
          <Type.Display size='L' font='nib'>
            Download the Robinhood&nbsp;Banking&nbsp;App
          </Type.Display>
          <Type.Text size='M' color={NeutralColorToken.Fg2}>
            Your Gold Card is ready to use immediately.
            <br />
            Get your card number in the app.
          </Type.Text>
          <Button
            label='Download app'
            state='default'
            width='full'
            type='anchor'
            href={downloadLink}
            target='_blank'
            rel='noopener noreferrer'
          />
        </div>
      </div>
    </div>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: 95vh;
  background-color: ${CssVars.neutral.bg1};
`;

const page = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  padding-top: calc(120px + env(safe-area-inset-top));
  padding-left: 44px;
  padding-right: 44px;
  padding-bottom: 44px;
  max-width: ${CREDIT_APPLICATION_PAGE_MAX_WIDTH}px;

  ${mediaQueryForExperimentalLayoutSizeMDOrSmaller} {
    padding-top: calc(44px + env(safe-area-inset-top));
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 24px;
  }
`;

const imageContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: ${CREDIT_APPLICATION_PAGE_MAX_WIDTH}px;
`;

const contentContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 24px;
  margin-top: -200px;
  justify-self: flex-end;
`;

const image = css`
  width: 100%;
`;

export default DownloadAppPageMobile;
